// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_previewRoot__z4iOP {
    /* Scoped here, not :root, so these don't leak into the host app once this directory
       moves into @gs/gs-integration-component. Values copied from the console's global
       App.css (gs-ui-templates/src/App.css), which is intentionally not ported here.
       --whastapp-preview-bg is misspelled upstream in the console itself — kept as-is
       since the background rule below references it by that exact name. */
    --gs-preview-button: #297c86;
    --gs-grey-900: #464646;
    --gs-primary-700: #7a6bdb;
    --gs-mint: #d4f0e9;
    --gs-grey-1000: #DBDBDB;
    --gs-grey-xs: #32373b;
    --gs-text-xxs: 0.625rem;
    --whastapp-preview-bg: url(https://gs-upload.gupshup.io/templates/images/template_preview_bg.png);
}

.style_previewContainer__rptfJ {
    height: 100%;
    overflow: hidden;
    padding: 1.25rem;
    min-height: 12rem;
    border-radius: 1.5rem;
    font-size: var(--typography-caption-fontSize);
    background: var(--whastapp-preview-bg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .style_header__1WJQt {
        color: var(--gs-grey-900);
        font-weight: var(--custom-fontWeight-600);
    }

    .style_body__x346M {
        padding: 0.625rem;
        border-radius: 0.9375rem;
        background-color: var(--palette-common-white);

        .style_footer__rdHDb {
            padding-top: 0.5rem;
            word-break: break-all;
            color: var(--palette-grey-800);
            font-size: var(--gs-text-xxs);
            font-weight: var(--typography-fontWeightMedium);
        }
    }
}

.style_previewLabel__3uuka {
    padding-bottom: 0.5rem;
    color: var(--palette-grey-600);
    font-size: var(--gs-text-xxs);
    font-weight: var(--typography-fontWeightMedium);
    text-transform: uppercase;
}

.style_payNowPanelAmount__uxjta {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 75px;
    background-color: var(--palette-grey-400);
}

.style_payNowPanelPayWith__-aZcZ {
    padding: 0.5rem 0.75rem ;
    background-color: var(--palette-grey-300);
    border-radius: 0px 0px 7px 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}

.style_payNowPanelPayWithIcon__fHzAM {
    background-color: var(--palette-common-white);
    border-radius: 10px;
    padding: 4px;
    border: 1px solid var(--palette-grey-500);
}

.style_msgPreviewContainer__k23i4 {
    height: 90%;
}

.style_timeStamp__pMD\\+p {
    text-align: end;
    padding: 0.5rem 0 0;
    color: var(--palette-grey-800);
    font-size: var(--gs-text-xxs);
    direction: ltr;
}

.style_listedButtons__GPOkV {
    cursor: pointer;
    padding: 0.65rem 1rem;
    word-break: break-word;
    font-size: var(--typography-caption-fontSize);
    color: var(--gs-preview-button);
    font-weight: var(--custom-fontWeight-600);
    border-top: 1px solid var(--gs-grey-1000);
}

.style_actionButtons__fS1Zi {
    margin: 0 -0.5rem;
    padding: 0.5625rem 1rem;
    color: var(--gs-preview-button);
    font-weight: var(--custom-fontWeight-600);
    border-top: 1px solid var(--gs-grey-1000);
}

.style_actionButtons__fS1Zi:last-child {
    padding: 0.5625rem 1rem 0.2rem;
}

.style_orderDetailsButton__rL-5V {
    margin-top: 0.625rem;
    border-radius: 0.625rem;
    background-color: var(--palette-common-white);

    .style_actionButtons__fS1Zi {
        border: none;
        padding: 0.5625rem 1rem;
    }
}

.style_carouselCardPanel__gCTkZ {
    gap: 0.4rem;
    display: flex;
    overflow: hidden;
    margin-top: 1rem;
    flex-direction: row;
    padding-bottom: 0.35rem;
}

.style_carouselCard__od2tL {
    padding: 0.5rem;
    min-width: 13.5rem;
    border-radius: 0.625rem;
    background-color: var(--palette-common-white);
    border: 1px solid var(--palette-grey-400);
}

.style_contentHeader__yWltM {
    padding-bottom: 6px;
    word-wrap: break-word;
    font-weight: var(--typography-fontWeightMedium);
    direction: ltr;
}

.style_content__h\\+ZdV {
    white-space: pre-wrap;
    word-break: break-word;
    color: var(--palette-common-black);
    font-weight: var(--typography-caption-fontWeight);
}

.style_productPanel__bE9UI {
    gap: 0.5rem;
    display: flex;
    padding: 0.4rem;
    align-items: center;
    min-height: 2.65rem;
    border-radius: 0.25rem;
    margin-bottom: 0.25rem;
    background-color: var(--palette-grey-200);
}

.style_productIcon__ypJq8 {
    height: 4rem;
    width: 4.5rem;
    align-items: center;
    display: inline-flex;
    border-radius: 0.25rem;
    justify-content: center;
    background-color: var(--palette-grey-700);
}

.style_productMessage__Z5rWC {
    width: 70%;
    gap: 0.125rem;
    display: flex;
    flex-direction: column;
}

.style_productSubHeader__tTUQk {
    font-size: var(--gs-text-xxs);
    font-weight: var(--typography-h2-fontWeight);
}

.style_orderStatusPanel__CYkhI {
    gap: 0.5rem;
    display: flex;
    padding: 0.5rem;
    align-items: center;
    min-height: 3.125rem;
    border-radius: 0.25rem;
    margin-bottom: 0.25rem;
    justify-content: space-between;
    background-color: var(--palette-grey-200);
    border-left: 5px solid var(--gs-primary-700);
}

.style_orderStatusHeader__umG\\+l {
    color: var(--gs-primary-700);
    font-size: var(--typography-body2-fontSize);
    font-weight: var(--typography-fontWeightMedium);
}

.style_orderStatusSubHeader__IVAaJ {
    gap: 0.3rem;
    display: flex;
    flex-direction: column;
    color: var(--palette-grey-800);
}

.style_orderDetailsPanel__FFPtc {
    gap: 0.5rem;
    display: flex;
    padding: 0.5rem;
    min-height: 3.125rem;
    border-radius: 0.25rem;
    margin-bottom: 0.25rem;
    flex-direction: column;
    background-color: var(--palette-grey-200);
}

.style_orderDetailsList__9Ra-n {
    gap: 0.8rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.625rem 0px;
    border-top: 1px dashed var(--palette-grey-600);
    border-bottom: 1px dashed var(--palette-grey-600);
}

.style_orderDetailsList__9Ra-n img {
    border-radius: 0.4rem;
}

.style_orderId__vkKS1 {
    color: var(--palette-grey-800);
    font-size: var(--gs-text-xxs);
}

.style_orderSubHeader__EwrQs {
    color: var(--gs-grey-xs);
    font-size: var(--typography-caption-fontSize);
}

.style_callPermissionPanel__4U-vc {
    gap: 0.5rem;
    display: flex;
    padding: 0.4rem;
    align-items: center;
    min-height: 2.65rem;
    border-radius: 0.25rem;
    margin-bottom: 0.25rem;
    background-color: var(--palette-grey-200);
}

.style_callPermissionIcon__ER2ts {
    padding: 0.5rem;
    border-radius: 50%;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    background-color: var(--palette-common-white);
}

.style_ltoPanel__tNO0V {
    gap: 0.5rem;
    display: flex;
    padding: 0.625rem;
    min-height: 3.125rem;
    border-radius: 0.25rem;
    margin-bottom: 0.625rem;
    background-color: var(--palette-grey-200);
}

.style_ltoIcon__tekat {
    width: 3rem;
    height: 3rem;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background-color: var(--gs-mint);
}

.style_ltoSubheader__-pUDz {
    color: var(--palette-common-black);
    font-size: var(--gs-text-xxs);
    font-weight: var(--typography-fontWeightMedium);
}

.style_ltoSubheaderCode__Xju6O {
    color: var(--palette-grey-600);
    font-size: var(--gs-text-xxs);
    font-weight: var(--custom-fontWeight-600);
}

.style_mediaPreviewPanel__mbmBC {
    border-radius: 0.25rem;
    position: relative;
}

.style_mediaPreviewPanel__mbmBC img {
    width: 100%;
}

.style_mediaPanel__Iz1S4 {
    width: 100%;
    max-height: 7rem;
    border-radius: 0.25rem;
}

.style_imagePanel__DfJZm {
    display: flex;
    justify-content: center;
}

.style_imagePanel__DfJZm img {
    width: 100%;
}

.style_scrollOnHover__t\\+UHT:hover {
    overflow: auto;
}

.style_tooglePreviewPanel__8\\+tmM {
    display: flex;
    padding: 0.2rem 0.8rem;
    justify-content: space-between;
}

.style_subHeader__mW66q {
    display: flex;
    align-items: center;
    color: var(--gs-grey-900);
    font-weight: var(--custom-fontWeight-600);
}

.style_togglePreviewBtn__1h34V {
    display: flex;
    cursor: pointer;
    border-radius: 0.4rem;
    padding: 0.5rem 0.8rem;
    border: 0.1rem solid var(--palette-grey-400);
}

.style_buttonListPanel__OnO4y {
    z-index: 1;
    width: 100%;
    bottom: 0px;
    display: flex;
    max-height: 70%;
    overflow-y: auto;
    position: absolute;
    flex-direction: column;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    background-color: var(--palette-common-white);
}

.style_buttonListHeader__-MRcY {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    padding: 1rem 1rem 0.5rem;
}

.style_optionHeader__aD\\+pQ {
    width: 100%;
    text-align: center;
    padding-bottom: 2rem;
    color: var(--gs-grey-900);
}

.style_disabledPreview__h67Cb {
    opacity: 0.4;
    align-items: center;
    pointer-events: none;
    justify-content: center;
    background-color: var(--palette-grey-400);
}

.style_inPreviewPanel__nA8Ml {

    .style_previewContainer__rptfJ {
        font-size: var(--typography-body2-fontSize);

        .style_body__x346M {

            .style_footer__rdHDb {
                font-size: var(--typography-body2-fontSize);
            }
        }
    }

    .style_timeStamp__pMD\\+p {
        font-size: var(--typography-caption-fontSize);
    }

    .style_listedButtons__GPOkV {
        font-size: var(--typography-body2-fontSize);
    }

    .style_orderSubHeader__EwrQs {
        font-size: var(--typography-body2-fontSize);
    }

    .style_ltoSubheader__-pUDz {
        font-size: var(--typography-caption-fontSize);
    }
}

.style_passkeyPanel__UvyCa {
    gap: 0.5rem;
    display: flex;
    padding: 0.75rem;
    border-radius: 0.25rem;
    margin-bottom: 0.75rem;
    align-items: flex-start;
    justify-content: space-between;
    background-color: var(--palette-grey-100);

    .style_passkeyIconWrapper__G5EpT {
        display: flex;
        padding: 0.5rem;
        border-radius: 50%;
        align-items: center;
        background-color: var(--palette-grey-400);
    }

    .style_passkeySubheader__VZdJO {
        font-size: var(--gs-text-xxs);
        color: var(--palette-grey-800);
    }
}

.style_skeletonLoader__Re3dg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #f2f2f240 25%, #e0e0e040 50%, #f2f2f240 75%);
    background-size: 200% 100%;
    animation: style_loading__jXDBW 1.5s infinite;
}

@keyframes style_loading__jXDBW {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TemplatePreview/style.module.css"],"names":[],"mappings":"AAAA;IACI;;;;0EAIsE;IACtE,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,iGAAiG;AACrG;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,6CAA6C;IAC7C,sCAAsC;IACtC,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;;IAE5B;QACI,yBAAyB;QACzB,yCAAyC;IAC7C;;IAEA;QACI,iBAAiB;QACjB,wBAAwB;QACxB,6CAA6C;;QAE7C;YACI,mBAAmB;YACnB,qBAAqB;YACrB,8BAA8B;YAC9B,6BAA6B;YAC7B,+CAA+C;QACnD;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,+BAA+B;IAC/B,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,+BAA+B;IAC/B,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,6CAA6C;;IAE7C;QACI,YAAY;QACZ,uBAAuB;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kCAAkC;IAClC,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,8BAA8B;IAC9B,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,4BAA4B;IAC5B,2CAA2C;IAC3C,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;IAC9C,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,+CAA+C;AACnD;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,4CAA4C;AAChD;;AAEA;IACI,UAAU;IACV,WAAW;IACX,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;;IAEI;QACI,2CAA2C;;QAE3C;;YAEI;gBACI,2CAA2C;YAC/C;QACJ;IACJ;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,6CAA6C;IACjD;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,yCAAyC;;IAEzC;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,yCAAyC;IAC7C;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+EAA+E;IAC/E,0BAA0B;IAC1B,6CAAgC;AACpC;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".previewRoot {\n    /* Scoped here, not :root, so these don't leak into the host app once this directory\n       moves into @gs/gs-integration-component. Values copied from the console's global\n       App.css (gs-ui-templates/src/App.css), which is intentionally not ported here.\n       --whastapp-preview-bg is misspelled upstream in the console itself — kept as-is\n       since the background rule below references it by that exact name. */\n    --gs-preview-button: #297c86;\n    --gs-grey-900: #464646;\n    --gs-primary-700: #7a6bdb;\n    --gs-mint: #d4f0e9;\n    --gs-grey-1000: #DBDBDB;\n    --gs-grey-xs: #32373b;\n    --gs-text-xxs: 0.625rem;\n    --whastapp-preview-bg: url(https://gs-upload.gupshup.io/templates/images/template_preview_bg.png);\n}\n\n.previewContainer {\n    height: 100%;\n    overflow: hidden;\n    padding: 1.25rem;\n    min-height: 12rem;\n    border-radius: 1.5rem;\n    font-size: var(--typography-caption-fontSize);\n    background: var(--whastapp-preview-bg);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    .header {\n        color: var(--gs-grey-900);\n        font-weight: var(--custom-fontWeight-600);\n    }\n\n    .body {\n        padding: 0.625rem;\n        border-radius: 0.9375rem;\n        background-color: var(--palette-common-white);\n\n        .footer {\n            padding-top: 0.5rem;\n            word-break: break-all;\n            color: var(--palette-grey-800);\n            font-size: var(--gs-text-xxs);\n            font-weight: var(--typography-fontWeightMedium);\n        }\n    }\n}\n\n.previewLabel {\n    padding-bottom: 0.5rem;\n    color: var(--palette-grey-600);\n    font-size: var(--gs-text-xxs);\n    font-weight: var(--typography-fontWeightMedium);\n    text-transform: uppercase;\n}\n\n.payNowPanelAmount {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 75px;\n    background-color: var(--palette-grey-400);\n}\n\n.payNowPanelPayWith {\n    padding: 0.5rem 0.75rem ;\n    background-color: var(--palette-grey-300);\n    border-radius: 0px 0px 7px 7px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n}\n\n.payNowPanelPayWithIcon {\n    background-color: var(--palette-common-white);\n    border-radius: 10px;\n    padding: 4px;\n    border: 1px solid var(--palette-grey-500);\n}\n\n.msgPreviewContainer {\n    height: 90%;\n}\n\n.timeStamp {\n    text-align: end;\n    padding: 0.5rem 0 0;\n    color: var(--palette-grey-800);\n    font-size: var(--gs-text-xxs);\n    direction: ltr;\n}\n\n.listedButtons {\n    cursor: pointer;\n    padding: 0.65rem 1rem;\n    word-break: break-word;\n    font-size: var(--typography-caption-fontSize);\n    color: var(--gs-preview-button);\n    font-weight: var(--custom-fontWeight-600);\n    border-top: 1px solid var(--gs-grey-1000);\n}\n\n.actionButtons {\n    margin: 0 -0.5rem;\n    padding: 0.5625rem 1rem;\n    color: var(--gs-preview-button);\n    font-weight: var(--custom-fontWeight-600);\n    border-top: 1px solid var(--gs-grey-1000);\n}\n\n.actionButtons:last-child {\n    padding: 0.5625rem 1rem 0.2rem;\n}\n\n.orderDetailsButton {\n    margin-top: 0.625rem;\n    border-radius: 0.625rem;\n    background-color: var(--palette-common-white);\n\n    .actionButtons {\n        border: none;\n        padding: 0.5625rem 1rem;\n    }\n}\n\n.carouselCardPanel {\n    gap: 0.4rem;\n    display: flex;\n    overflow: hidden;\n    margin-top: 1rem;\n    flex-direction: row;\n    padding-bottom: 0.35rem;\n}\n\n.carouselCard {\n    padding: 0.5rem;\n    min-width: 13.5rem;\n    border-radius: 0.625rem;\n    background-color: var(--palette-common-white);\n    border: 1px solid var(--palette-grey-400);\n}\n\n.contentHeader {\n    padding-bottom: 6px;\n    word-wrap: break-word;\n    font-weight: var(--typography-fontWeightMedium);\n    direction: ltr;\n}\n\n.content {\n    white-space: pre-wrap;\n    word-break: break-word;\n    color: var(--palette-common-black);\n    font-weight: var(--typography-caption-fontWeight);\n}\n\n.productPanel {\n    gap: 0.5rem;\n    display: flex;\n    padding: 0.4rem;\n    align-items: center;\n    min-height: 2.65rem;\n    border-radius: 0.25rem;\n    margin-bottom: 0.25rem;\n    background-color: var(--palette-grey-200);\n}\n\n.productIcon {\n    height: 4rem;\n    width: 4.5rem;\n    align-items: center;\n    display: inline-flex;\n    border-radius: 0.25rem;\n    justify-content: center;\n    background-color: var(--palette-grey-700);\n}\n\n.productMessage {\n    width: 70%;\n    gap: 0.125rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.productSubHeader {\n    font-size: var(--gs-text-xxs);\n    font-weight: var(--typography-h2-fontWeight);\n}\n\n.orderStatusPanel {\n    gap: 0.5rem;\n    display: flex;\n    padding: 0.5rem;\n    align-items: center;\n    min-height: 3.125rem;\n    border-radius: 0.25rem;\n    margin-bottom: 0.25rem;\n    justify-content: space-between;\n    background-color: var(--palette-grey-200);\n    border-left: 5px solid var(--gs-primary-700);\n}\n\n.orderStatusHeader {\n    color: var(--gs-primary-700);\n    font-size: var(--typography-body2-fontSize);\n    font-weight: var(--typography-fontWeightMedium);\n}\n\n.orderStatusSubHeader {\n    gap: 0.3rem;\n    display: flex;\n    flex-direction: column;\n    color: var(--palette-grey-800);\n}\n\n.orderDetailsPanel {\n    gap: 0.5rem;\n    display: flex;\n    padding: 0.5rem;\n    min-height: 3.125rem;\n    border-radius: 0.25rem;\n    margin-bottom: 0.25rem;\n    flex-direction: column;\n    background-color: var(--palette-grey-200);\n}\n\n.orderDetailsList {\n    gap: 0.8rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0.625rem 0px;\n    border-top: 1px dashed var(--palette-grey-600);\n    border-bottom: 1px dashed var(--palette-grey-600);\n}\n\n.orderDetailsList img {\n    border-radius: 0.4rem;\n}\n\n.orderId {\n    color: var(--palette-grey-800);\n    font-size: var(--gs-text-xxs);\n}\n\n.orderSubHeader {\n    color: var(--gs-grey-xs);\n    font-size: var(--typography-caption-fontSize);\n}\n\n.callPermissionPanel {\n    gap: 0.5rem;\n    display: flex;\n    padding: 0.4rem;\n    align-items: center;\n    min-height: 2.65rem;\n    border-radius: 0.25rem;\n    margin-bottom: 0.25rem;\n    background-color: var(--palette-grey-200);\n}\n\n.callPermissionIcon {\n    padding: 0.5rem;\n    border-radius: 50%;\n    align-items: center;\n    display: inline-flex;\n    justify-content: center;\n    background-color: var(--palette-common-white);\n}\n\n.ltoPanel {\n    gap: 0.5rem;\n    display: flex;\n    padding: 0.625rem;\n    min-height: 3.125rem;\n    border-radius: 0.25rem;\n    margin-bottom: 0.625rem;\n    background-color: var(--palette-grey-200);\n}\n\n.ltoIcon {\n    width: 3rem;\n    height: 3rem;\n    display: flex;\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--gs-mint);\n}\n\n.ltoSubheader {\n    color: var(--palette-common-black);\n    font-size: var(--gs-text-xxs);\n    font-weight: var(--typography-fontWeightMedium);\n}\n\n.ltoSubheaderCode {\n    color: var(--palette-grey-600);\n    font-size: var(--gs-text-xxs);\n    font-weight: var(--custom-fontWeight-600);\n}\n\n.mediaPreviewPanel {\n    border-radius: 0.25rem;\n    position: relative;\n}\n\n.mediaPreviewPanel img {\n    width: 100%;\n}\n\n.mediaPanel {\n    width: 100%;\n    max-height: 7rem;\n    border-radius: 0.25rem;\n}\n\n.imagePanel {\n    display: flex;\n    justify-content: center;\n}\n\n.imagePanel img {\n    width: 100%;\n}\n\n.scrollOnHover:hover {\n    overflow: auto;\n}\n\n.tooglePreviewPanel {\n    display: flex;\n    padding: 0.2rem 0.8rem;\n    justify-content: space-between;\n}\n\n.subHeader {\n    display: flex;\n    align-items: center;\n    color: var(--gs-grey-900);\n    font-weight: var(--custom-fontWeight-600);\n}\n\n.togglePreviewBtn {\n    display: flex;\n    cursor: pointer;\n    border-radius: 0.4rem;\n    padding: 0.5rem 0.8rem;\n    border: 0.1rem solid var(--palette-grey-400);\n}\n\n.buttonListPanel {\n    z-index: 1;\n    width: 100%;\n    bottom: 0px;\n    display: flex;\n    max-height: 70%;\n    overflow-y: auto;\n    position: absolute;\n    flex-direction: column;\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n    background-color: var(--palette-common-white);\n}\n\n.buttonListHeader {\n    gap: 1rem;\n    display: flex;\n    flex-direction: row;\n    padding: 1rem 1rem 0.5rem;\n}\n\n.optionHeader {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 2rem;\n    color: var(--gs-grey-900);\n}\n\n.disabledPreview {\n    opacity: 0.4;\n    align-items: center;\n    pointer-events: none;\n    justify-content: center;\n    background-color: var(--palette-grey-400);\n}\n\n.inPreviewPanel {\n\n    .previewContainer {\n        font-size: var(--typography-body2-fontSize);\n\n        .body {\n\n            .footer {\n                font-size: var(--typography-body2-fontSize);\n            }\n        }\n    }\n\n    .timeStamp {\n        font-size: var(--typography-caption-fontSize);\n    }\n\n    .listedButtons {\n        font-size: var(--typography-body2-fontSize);\n    }\n\n    .orderSubHeader {\n        font-size: var(--typography-body2-fontSize);\n    }\n\n    .ltoSubheader {\n        font-size: var(--typography-caption-fontSize);\n    }\n}\n\n.passkeyPanel {\n    gap: 0.5rem;\n    display: flex;\n    padding: 0.75rem;\n    border-radius: 0.25rem;\n    margin-bottom: 0.75rem;\n    align-items: flex-start;\n    justify-content: space-between;\n    background-color: var(--palette-grey-100);\n\n    .passkeyIconWrapper {\n        display: flex;\n        padding: 0.5rem;\n        border-radius: 50%;\n        align-items: center;\n        background-color: var(--palette-grey-400);\n    }\n\n    .passkeySubheader {\n        font-size: var(--gs-text-xxs);\n        color: var(--palette-grey-800);\n    }\n}\n\n.skeletonLoader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, #f2f2f240 25%, #e0e0e040 50%, #f2f2f240 75%);\n    background-size: 200% 100%;\n    animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n    0% {\n        background-position: 200% 0;\n    }\n\n    100% {\n        background-position: -200% 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewRoot": `style_previewRoot__z4iOP`,
	"previewContainer": `style_previewContainer__rptfJ`,
	"header": `style_header__1WJQt`,
	"body": `style_body__x346M`,
	"footer": `style_footer__rdHDb`,
	"previewLabel": `style_previewLabel__3uuka`,
	"payNowPanelAmount": `style_payNowPanelAmount__uxjta`,
	"payNowPanelPayWith": `style_payNowPanelPayWith__-aZcZ`,
	"payNowPanelPayWithIcon": `style_payNowPanelPayWithIcon__fHzAM`,
	"msgPreviewContainer": `style_msgPreviewContainer__k23i4`,
	"timeStamp": `style_timeStamp__pMD+p`,
	"listedButtons": `style_listedButtons__GPOkV`,
	"actionButtons": `style_actionButtons__fS1Zi`,
	"orderDetailsButton": `style_orderDetailsButton__rL-5V`,
	"carouselCardPanel": `style_carouselCardPanel__gCTkZ`,
	"carouselCard": `style_carouselCard__od2tL`,
	"contentHeader": `style_contentHeader__yWltM`,
	"content": `style_content__h+ZdV`,
	"productPanel": `style_productPanel__bE9UI`,
	"productIcon": `style_productIcon__ypJq8`,
	"productMessage": `style_productMessage__Z5rWC`,
	"productSubHeader": `style_productSubHeader__tTUQk`,
	"orderStatusPanel": `style_orderStatusPanel__CYkhI`,
	"orderStatusHeader": `style_orderStatusHeader__umG+l`,
	"orderStatusSubHeader": `style_orderStatusSubHeader__IVAaJ`,
	"orderDetailsPanel": `style_orderDetailsPanel__FFPtc`,
	"orderDetailsList": `style_orderDetailsList__9Ra-n`,
	"orderId": `style_orderId__vkKS1`,
	"orderSubHeader": `style_orderSubHeader__EwrQs`,
	"callPermissionPanel": `style_callPermissionPanel__4U-vc`,
	"callPermissionIcon": `style_callPermissionIcon__ER2ts`,
	"ltoPanel": `style_ltoPanel__tNO0V`,
	"ltoIcon": `style_ltoIcon__tekat`,
	"ltoSubheader": `style_ltoSubheader__-pUDz`,
	"ltoSubheaderCode": `style_ltoSubheaderCode__Xju6O`,
	"mediaPreviewPanel": `style_mediaPreviewPanel__mbmBC`,
	"mediaPanel": `style_mediaPanel__Iz1S4`,
	"imagePanel": `style_imagePanel__DfJZm`,
	"scrollOnHover": `style_scrollOnHover__t+UHT`,
	"tooglePreviewPanel": `style_tooglePreviewPanel__8+tmM`,
	"subHeader": `style_subHeader__mW66q`,
	"togglePreviewBtn": `style_togglePreviewBtn__1h34V`,
	"buttonListPanel": `style_buttonListPanel__OnO4y`,
	"buttonListHeader": `style_buttonListHeader__-MRcY`,
	"optionHeader": `style_optionHeader__aD+pQ`,
	"disabledPreview": `style_disabledPreview__h67Cb`,
	"inPreviewPanel": `style_inPreviewPanel__nA8Ml`,
	"passkeyPanel": `style_passkeyPanel__UvyCa`,
	"passkeyIconWrapper": `style_passkeyIconWrapper__G5EpT`,
	"passkeySubheader": `style_passkeySubheader__VZdJO`,
	"skeletonLoader": `style_skeletonLoader__Re3dg`,
	"loading": `style_loading__jXDBW`
};
export default ___CSS_LOADER_EXPORT___;
